import React,{ useState, useContext, useEffect, useRef } from 'react';
import { Link, redirect, Route, Routes, useNavigate }                      from 'react-router-dom';
import axios  from 'axios';

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Menu              from '@mui/material/Menu';
import Popover           from '@mui/material/Popover';
import Divider           from '@mui/material/Divider';

import { AppAuthGlobalVariables } from '../../contexts/AppAuthContext';
import { AuthContext } from '../../contexts/authContext';
import CircleProgress  from '../../components/CircleProgress/CircleProgress';
import config          from '../../config';
import './index.css';

import {ReactComponent as SysCubeLogo}  from '../../assets/svgs/systrategy_cube_logo.svg';
import {ReactComponent as SysWordLogo}  from '../../assets/svgs/systrategy_word_logo.svg';

import CircularProgress from '@mui/material/CircularProgress';

import Collapse from '@mui/material/Collapse';
import {    
    AccountCircleSolidIcon,
    LogoutIcon,
    ImpersonateIcon,
    ImpersonateIconEnd,
} from '../../assets/icons/icons';
import { NotificationManager } from 'react-notifications';
import { Button } from '@mui/material';

import MfaSettings from './userOptions/mfaSettings/MfaSettings';
import Home from './home/Home';
import ChangePassword from './userOptions/changePassword/ChangePassword';

import Page403 from './errorPages/Page403';
import Page404 from './errorPages/Page404';
import Page500 from './errorPages/Page500';
import AsideMenu from '../../components/AsideMenu/AsideMenu';
import UserList from './users/UserList';
import UserDetails from './users/UserDetails';
import UserRoles from './users/UserRoles';
import AdminManagement from './adminManagement/AdminManagement';
import Import from './import/Import';

const getCookieByName = (name) => {
    const cookieString = document.cookie;
    const cookies = cookieString.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return cookie.substring(name.length + 1);
        }
    }
    return null;
};

function MainIndex() {
    const navigate = useNavigate();
    const { pageName, userEmail, setUserEmail, setPrivs, privs } = useContext(AppAuthGlobalVariables);
    const auth = useContext(AuthContext);
    const MFAtoConfig = localStorage.getItem('isMFAToConfig') === 'true';

    const [ loading, setLoading ] = useState(true);
    const [ sideHover, setSideHover ] = useState(false);

    const [hardLoading, setHardLoading] = useState(true);

    const [ anchorUserSetting ,setAnchorUserSetting  ] = useState(null);
    const [ anchorSettings    ,setAnchorSettings     ] = useState(null);
    const [ anchorNotify      ,setAnchorNotify       ] = useState(null);

    const [ selectedPage, setSelectedPage ] = useState('dashboard');

    const [ adminUser, setAdminUser ] = useState(true);
    const [ isUserInImpersonate, setIsUserInImpersonate ] = useState(false);

    useEffect(() => {
        async function init () {
            if(MFAtoConfig)navigate('/mfa-setup');
            //let appPrivs = localStorage.getItem('privs');
            /* setIsUserInImpersonate(false);
            localStorage.removeItem('impersonateKUser'); */
            await getProfile();

            if(!MFAtoConfig){
                let hubRefreshToken = getCookieByName(`hubRefreshToken${process.env.REACT_APP_ENV}`);
                let hubAccessToken = getCookieByName(`hubAccessToken${process.env.REACT_APP_ENV}`);
                let hubIdToken = getCookieByName(`hubIdToken${process.env.REACT_APP_ENV}`);

                if(!hubRefreshToken || !hubAccessToken || !hubIdToken)await auth.updateMissingTokensFromLoggedInSession();
            }

            setHardLoading(false);
        }
        init();
        setLoading(false);
    },[])

    const getProfile = async() => {
        try{
            let axiosParams = {
                url: 'profile',
                method: 'get',
                baseURL: config.API_URL,
                headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`},
            }

            let response = await axios(axiosParams);
            if(response.status === 200){
                setAdminUser(response.data.FLAG_ADMIN === 'Y' ? true : false);
                setUserEmail?.(response.data.EMAIL_ADDRESS);

                setPrivs({
                    P_CIRCULATION: response.data.P_CIRCULATION,
                    P_PROVVIGIONI: response.data.P_PROVVIGIONI,
                    P_AVB: response.data.P_AVB,
                    P_ROOBEEK: response.data.P_ROOBEEK,
                    P_ADBOOK: response.data.P_ADBOOK,
                    P_WORKDAY: response.data.P_WORKDAY,
                    P_SF_PORTFOLIO: response.data.P_SF_PORTFOLIO,
                    P_ANAGRAFICHE_CLI_AGE: response.data.P_ANAGRAFICHE_CLI_AGE,
                    P_PROGRAMMATIC_PG: response.data.P_PROGRAMMATIC_PG,
                    P_PROGRAMMATIC_PP: response.data.P_PROGRAMMATIC_PP,
                    P_MANUAL_ADJUSTMENTS: response.data.P_MANUAL_ADJUSTMENTS
                })
            }
        }catch (e){
            if(e?.response?.status===500){
                NotificationManager.error((typeof e.response.data.errorMessage === 'object' ? '' : e.response.data.errorMessage), 'Error', 10000);
            }else if(e?.response?.status===401){
                NotificationManager.error('Not Authorized', 'Error', 10000);
                logOut();
            }else{
                NotificationManager.error('Connection Error', 'Error', 10000);
            }
        }
    }

    const goToHome = () => {
        navigate(config.HOME_PAGE);
    };

    const handleOpen = ( event, target ) =>{
        let targetCoords = (event.currentTarget);
        switch ( target ) {
            case 'user-settings':
                setAnchorUserSetting(targetCoords);
                break;

            case 'notify':
                setAnchorNotify(targetCoords);
                break;                

            case 'settings':
                setAnchorSettings(targetCoords);
                break;

            default:
                console.log('hmm, mumble...');
                break;
        }
    };

    const handleClose = (target) => {
        switch ( target ) {
            case 'user-settings':
                setAnchorUserSetting(null);
                break;

            case 'notify':
                setAnchorNotify(null);
                break;                

            case 'settings':
                setAnchorSettings(null);
                break;

            default:
                console.log('hmm, mumble...');
                break;
        }
    };

    const goToChangePassword = () => {
        handleClose();
        navigate('/change-password');
    }

    const goToImpersonate = () => {
        handleClose();
        navigate('/impersona');
    }

    const logOut = async(fromMfa = false) =>{
        try {
            handleClose();
        if(fromMfa){
            auth.signOut(); 
            navigate('/login?out=userRequest')
        }else{
            await auth.logoutInvalidateAllTokens();
            navigate('/login?out=userRequest');
        }
        } catch (error) {
            console.log('logout try catch', error.message)
        }
        
    }

    const endImpersonate = async() => {
        setIsUserInImpersonate(false);
        localStorage.removeItem('impersonateKUser');
        await getProfile();
        let loggedEmail = '';
        let userAttributes = await auth.getAttributes();
        let emailUserObj = userAttributes.find(attribute => attribute.Name === 'email');
        loggedEmail = emailUserObj?.Value;
        setUserEmail?.(loggedEmail);
    }

    if ( MFAtoConfig ) {
        return (
            <div className={"main-background"}>
                {
                    loading ? <CircleProgress /> : 
                    <>
                        <div className="main-content-mfa">
                            <div className="header-config-mfa">
                                <div className="header-container">
                                    <div>
                                        <span className="app-name cursor-defaul">Condenast-Hub</span>
                                        <span className="app-name page-name cursor-defaul"> | {pageName} </span>
                                    </div>
                                    {/* dropdown-user-settings */}
                                    {/* {userText} */}

                                    <Button className="logout-button-container dropdown-user-options" onClick={(e) => logOut(true)} startIcon={<LogoutIcon />}>Exit</Button>
                                </div>
                            </div>
                            <Routes>  
                                <Route path="/*"  element={<MfaSettings/>}/>
                            </Routes>
                        </div>
                    </>
                }
            </div>
        )
    } else if(hardLoading){
        return(
            <div className={"main-background"} style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                <CircularProgress />
            </div>
        )
    } else {
        return (
            <div className={"main-background"}>
                {
                    loading ? <CircleProgress /> : <>
                        <AsideMenu alwaysOpen={true} userIsAdmin={adminUser}/>
                        <div className="main-content">
                            <div className={`header ${config.ENV === 'Prod' ? '' : `notprodenv-${config.ENV}`}`}>
                                <div className="header-container">
                                    <div className='text-notprodenv'>
                                        {config.ENV === 'Prod' ? '' : `${config.ENV} ENVIRONMENT`}
                                        {/* <span className="app-name cursor-pointer" onClick={goToHome}>Spooky Scary Skeletons</span>
                                        <span className="app-name cursor-default page-name"> | {pageName} </span> */}
                                    </div>
                                    <div className="header-container-tools">
                                        <div>
                                            {isUserInImpersonate && (<ImpersonateIcon addClass='font-20'/>)}
                                        </div>
                                        <div className="user-settings-wrapper cursor-pointer" onClick={(event) => handleOpen(event, 'user-settings')}>
                                            <span>{userEmail}</span>
                                            <AccountCircleSolidIcon />
                                            <Popover
                                                open={Boolean(anchorUserSetting)}
                                                anchorEl={anchorUserSetting}
                                                onClose={() => handleClose('user-settings')}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                            >
                                                <ClickAwayListener onClickAway={() => handleClose('user-settings')}>
                                                    <div className="dropdown-user-settings">
                                                        {/* <Button className="dropdown-user-options" onClick={goToChangePassword} startIcon={<KeyIcon/>}>Cambia Password</Button> */}
                                                        {/* {(adminUser || isUserInImpersonate)&&
                                                            <Button 
                                                                className="dropdown-user-options"
                                                                onClick={isUserInImpersonate ? endImpersonate : goToImpersonate}
                                                                startIcon={isUserInImpersonate ? <ImpersonateIconEnd/> : <ImpersonateIcon/>}>
                                                                    {isUserInImpersonate ? 'Fine Impersona' : 'Impersona'}
                                                            </Button>} */}
                                                        <Button className="dropdown-user-options" onClick={() => logOut()} startIcon={<LogoutIcon />}>Logout</Button>
                                                    </div>
                                                </ClickAwayListener>
                                            </Popover>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Routes>
                                <Route path="/home" element={<Home {...{logOut}}/>}/>
                                {(adminUser || !(
                                    privs.P_ADBOOK              < 'R' &&
                                    privs.P_WORKDAY             < 'R' &&
                                    privs.P_SF_PORTFOLIO        < 'R' &&
                                    privs.P_ANAGRAFICHE_CLI_AGE < 'R' &&
                                    privs.P_PROGRAMMATIC_PG     < 'R' &&
                                    privs.P_PROGRAMMATIC_PP     < 'R' &&
                                    privs.P_MANUAL_ADJUSTMENTS  < 'R' 
                                ))&&(<Route path="/import" element={<Import {...{logOut}}/>}/>)}

                                {adminUser && (<Route path="/users/list" element={<UserList />}/>)}                     
                                {adminUser && (<Route path="/users/account-details/:kUser" element={<UserDetails />}/>)}     
                                {adminUser && (<Route path="/users/roles" element={<UserRoles />}/>)}  

                                <Route path="/change-password" element={<ChangePassword {...{logOut}}/>}/>

                                <Route path="/500"  element={<Page500/>}/>
                                <Route path="/403"  element={<Page403/>}/>
                                <Route path="/*"    element={<Page404/>}/>
                            </Routes>
                        </div>
                    </>
                }
            </div>
        )
    }
}

export default MainIndex;